import React, { useEffect, useState, useContext } from "react";
import { SocketContext } from "../../../context/SocketContext";
import Modal from "react-bootstrap/Modal";
import { useUnidades } from "../../../hooks/test/useUnidades";
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import moment from "moment";
import "moment/locale/es-mx";
import {
  faLocationDot,
  faMapLocationDot,
  faTrashRestore,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spinner, Table } from "react-bootstrap";
import Swal from "sweetalert2";

// 🎨 Tema oscuro global — letras blancas
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#1e1e1e",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#cccccc",
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#333333",
          color: "#ffffff",
          fontWeight: "bold",
        },
        body: {
          backgroundColor: "#1e1e1e",
          color: "#ffffff",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          color: "#ffffff", // título y toolbar de MUIDataTable
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#ffffff", // textos de filtros, títulos, paginación
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: "#ffffff", // texto de inputs como search
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#ffffff", // íconos en toolbar
        },
      },
    },
  },
});

// Se muestra bitacora de ultimo evento de unidades por cedis a partir del nombre del cedis
export const BitacoraUnidadesModal = ({
  status,
  nombreCedis,
  show,
  handleClose,
}) => {
  const { getStatsUnidadesBitacora } = useUnidades();

  const [cache, setCache] = useState({}); // ✅ cache local por CEDIS
  const [data, setData] = useState([]);
  const [tittle, setTittle] = useState("Total Protect");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!nombreCedis || !show) return;

    // Limpiamos data antes de cargar nueva
    setTittle(nombreCedis);
    setData([]);

    // Si ya está en cache, usamos eso y evitamos petición
    if (cache[nombreCedis]) {
      setData(cache[nombreCedis]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        setData([]);
        const resp = await getStatsUnidadesBitacora(
          nombreCedis,
          status === "UNIDAD EN RUTA" ? 3 : 1,
        );
        if (
          resp.ok &&
          status === "UNIDAD EN RUTA" &&
          Array.isArray(resp.data.enRuta.unidades)
        ) {
          debugger;
          const array = resp.data.enRuta.unidades.map(
            ({ unidad_numero, viajes, coordenadas, fecha_posicion }) => {
              const evento = viajes[0].bitacora_monitorista[0] || {};
              return [
                unidad_numero || "N/A",
                evento.status.nombre || "N/A",
                moment(evento.bitacora_fecha_hora).format("lll") || "N/A",
                evento.direccion || "N/A",
                evento.latitud && evento.longuitud
                  ? `${evento.latitud}, ${evento.longuitud}`
                  : "N/A",
                viajes[0].ruta
                  ? viajes[0].ruta
                      .map((d) => d.tienda.tienda_nombre || "N/A")
                      .join(", ")
                  : "N/A",
                coordenadas,
                moment(fecha_posicion).format("lll") || "N/A",
                <>
                  <FontAwesomeIcon
                    onClick={() => {
                      if (!evento.latitud) return;
                      MapButton(`${evento.latitud}, ${evento.longuitud}`);
                    }}
                    className="col-4"
                    icon={faMapLocationDot}
                    style={{
                      color: coordenadas === "00.00,00.00" ? "gray" : "green",
                      cursor:
                        coordenadas === "00.00,00.00"
                          ? "not-allowed"
                          : "pointer",
                      opacity: coordenadas === "00.00,00.00" ? 0.5 : 1,
                    }}
                    title={
                      coordenadas === "00.00,00.00"
                        ? "Sin coordenadas válidas"
                        : "Ver posición evento"
                    }
                  ></FontAwesomeIcon>
                  <FontAwesomeIcon
                    onClick={() => {
                      if (coordenadas === "00.00,00.00") return;
                      MapButton(coordenadas);
                    }}
                    className="col-4"
                    icon={faLocationDot}
                    style={{
                      color: coordenadas === "00.00,00.00" ? "gray" : "blue",
                      cursor:
                        coordenadas === "00.00,00.00"
                          ? "not-allowed"
                          : "pointer",
                      opacity: coordenadas === "00.00,00.00" ? 0.5 : 1,
                    }}
                    title={
                      coordenadas === "00.00,00.00"
                        ? "Sin coordenadas válidas"
                        : "Ver posición plataforma"
                    }
                  ></FontAwesomeIcon>
                </>,
              ];
            },
          );

          setData(array);
        } else if (
          resp.ok &&
          status === "UNIDAD DISPONIBLE" &&
          Array.isArray(resp.data.disponible.disponibles)
        ) {
          const array = resp.data.disponible.disponibles.map(
            ({ unidad_numero, unidad_vin, coordenadas, fecha_posicion }) => {
              return [
                unidad_numero || "N/A",
                unidad_vin || "N/A",
                moment(fecha_posicion).format("lll") || "N/A",
                coordenadas || "N/A",
                <FontAwesomeIcon
                  onClick={() => {
                    if (coordenadas === "00.00,00.00") return;
                    MapButton(coordenadas);
                  }}
                  icon={faLocationDot}
                  style={{
                    color: coordenadas === "00.00,00.00" ? "gray" : "green",
                    cursor:
                      coordenadas === "00.00,00.00" ? "not-allowed" : "pointer",
                    opacity: coordenadas === "00.00,00.00" ? 0.5 : 1,
                  }}
                  title={
                    coordenadas === "00.00,00.00"
                      ? "Sin coordenadas válidas"
                      : "Ver posición plataforma"
                  }
                ></FontAwesomeIcon>,
              ];
            },
          );
          setData(array);
        } else {
          debugger;
          setData([]);
          setCache((prev) => ({ ...prev, [nombreCedis]: [] }));
        }
      } catch (error) {
        console.error("Error al cargar bitácora:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [nombreCedis, show]);

  const MapButton = (coordenadas) => {
    const url = `https://www.google.com/maps?q=${coordenadas}`;
    window.open(url, "_blank"); // Abre en una nueva pestaña
  };
  let columns = [];
  if (status === "UNIDAD EN RUTA") {
    columns = [
      { name: "Unidad", label: "Unidad" },
      { name: "Ultimo evento", label: "Ultimo evento" },
      { name: "Fecha/Hora", label: "Fecha/Hora" },
      { name: "Dirección Evento", label: "Dirección Evento" },
      {
        name: "Coordenadas",
        label: "Coordenadas",
        options: {
          display: true, // 👈 oculta en tabla
          download: true, // 👈 pero sí se exporta
        },
      },
      { name: "Destinos", label: "Destinos" },
      {
        name: "Posición plataforma",
        label: "Posición plataforma",
        options: {
          display: false, // 👈 oculta en tabla
          download: true, // 👈 pero sí se exporta
        },
      },
      { name: "Fecha/Hora ultmo reporte", label: "Fecha/Hora ultmo reporte" },
      {
        name: "Acción",
        label: "Acción",
        options: {
          download: false, // 👈 visible pero no se exporta
          filter: false,
          sort: false,
        },
      },
    ];
  } else {
    columns = [
      { name: "Unidad", label: "Unidad" },
      { name: "Número de serie", label: "Número de serie" },
      {
        name: "Utimo reporte en plataforma",
        label: "Utimo reporte en plataforma",
      },
      {
        name: "Coordenadas",
        label: "Coordenadas",
        options: {
          display: true, // 👈 oculta en tabla
          download: true, // 👈 pero sí se exporta
        },
      },
      {
        name: "Acción",
        label: "Acción",
        options: {
          download: false, // 👈 visible pero no se exporta
          filter: false,
          sort: false,
        },
      },
    ];
  }
  const now = new Date();
  const formattedDate = `${now.getFullYear()}-${String(
    now.getMonth() + 1,
  ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours(),
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  const filename = `${status} DEL ${tittle} ${formattedDate}`;
  const options = {
    selectableRows: "none",
    responsive: "standard", // mejor para tablas anchas
    fixedHeader: true, // mantiene header visible al hacer scroll
    downloadOptions: {
      filename: filename,
      filterOptions: {
        useDisplayedColumnsOnly: false, // 👈 exporta también las ocultas
        useDisplayedRowsOnly: true,
      },
      charset: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) =>
      "\uFEFF" + buildHead(columns) + buildBody(data),
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose(); // cierra el modal
        setData([]); // limpia la tabla
        setCache({}); // limpia el cache
      }}
      backdrop="static" // evita cerrar al hacer click fuera
      keyboard={false} // evita cerrar con ESC
      centered // centra verticalmente
      size="xl" // más ancho para tablas grandes
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
                variant="primary"
              />{" "}
              Cargando detalle...
            </>
          ) : (
            `BITÁCORA DEL ${nombreCedis}`
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <ThemeProvider theme={darkTheme}>
          <MUIDataTable
            title={
              status === "UNIDAD DISPONIBLE"
                ? `BITÁCORA ${status}`
                : status === "UNIDAD EN RUTA"
                  ? `BITÁCORA ${status}`
                  : "BITÁCORA DE MOVIMIENTOS"
            }
            data={data}
            columns={columns}
            options={options}
          />
        </ThemeProvider>
      </Modal.Body>
    </Modal>
  );
};

// Se muestra la bitacora de ultimo evento del tripulante(s) a partir del tripulante_id
export const BitacoraUnidadModal = ({
  tripulante_id,
  show,
  handleClose,
  refreshTripulantes,
}) => {
  const {
    getTripulantev2, // se obtiene el tripulante para pintarlo
    putReasignarUnidad, // se finaliza viaje automatico
    putViajeStatusV2, // se finaliza viaje manual
    getViajeUnidad, // se obtiene el viaje manual por unidad
    postBitacora, // guarda evento en bitacora al finalizar el viaje
    putStatusTripulante, //  si no hay viaje m-a se libera el tripulante
  } = useUnidades();
  const { socket } = useContext(SocketContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!tripulante_id || !show) return;

    setData(null);

    const fetchData = async () => {
      try {
        const resp = await getTripulantev2(tripulante_id);

        if (resp.ok) {
          setData(resp.tripulante);
        } else {
          setData(null);
        }
      } catch (error) {
        console.error("Error al cargar bitácora:", error);
        setData(null);
      }
    };

    fetchData();
  }, [tripulante_id, show]);

  const liberarUnidad = async () => {
    if (!data) return;

    const tripulante = data;

    setLoading(true);

    try {
      let successMsg = "";

      if (tripulante?.asignacion?.viaje?.tipo === "Manual") {
        const viajeUnidad = await getViajeUnidad(
          tripulante.asignacion.unidad.id,
        );

        if (viajeUnidad.ok && viajeUnidad.viaje_activo) {
          const viajeStatus = await putViajeStatusV2(viajeUnidad.viaje_id, 8);

          if (!viajeStatus.ok) {
            await Swal.fire({
              title: "Lo siento!",
              text: viajeStatus.msg,
              icon: "info",
            });
            return;
          }

          await postBitacora({
            id_viaje: viajeUnidad.viaje_id,
            notas: "La unidad fue liberada",
            id_status: 8,
          });
        }

        successMsg = "Tripulante liberado";

        socket.emit("traer-unidades-en-ruta_", {
          idNegocio: tripulante.negocio_id,
        });
      } else if (tripulante?.asignacion?.viaje?.tipo === "Automatico") {
        debugger
        const liberar = await putReasignarUnidad(
          tripulante.asignacion.unidad.id,
        );

        if (!liberar.ok) {
          await Swal.fire({
            title: "Lo siento!",
            text: liberar.msg,
            icon: "info",
          });
          return;
        }

        successMsg = liberar.msg;

        socket.emit("traer-unidades-en-ruta_", {
          idNegocio: tripulante.negocio_id,
        });
      } else {
        const liberar = await putStatusTripulante(tripulante.tripulante_id, {
          ocupado: false,
        });

        if (!liberar.ok) {
          await Swal.fire({
            title: "Lo siento!",
            text: liberar.msg,
            icon: "info",
          });
          return;
        }

        successMsg = liberar.msg;
      }

      await Swal.fire({
        title: "Completado!",
        text: successMsg,
        icon: "success",
      });

      handleClose();

      if (refreshTripulantes) {
        refreshTripulantes();
      }
    } catch (error) {
      console.error("Error en liberarUnidad:", error);

      await Swal.fire({
        title: "Error",
        text: "Hubo un problema al liberar.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        if (!loading) {
          // 🔹 Solo permite cerrar si no está cargando
          handleClose();
          setData(null);
        }
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="xl"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Asignación del tripulante</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Unidad</th>
              <th>Tipo de viaje</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {data ? (
              <tr>
                <td>{data.nombre_completo}</td>
                <td>{data.telefono}</td>
                <td>{data.asignacion ? data.asignacion.unidad.numero : "-"}</td>
                <td>{data.asignacion ? data.asignacion.viaje.tipo : "-"}</td>
                <td className="text-center">
                  {loading ? (
                    <>
                      {" "}
                      <Spinner
                        as="span"
                        animation="border"
                        variant="success"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      {" Liberando..."}
                    </>
                  ) : (
                    <FontAwesomeIcon
                      icon={faTrashRestore}
                      className="fa-2x cursor"
                      title={
                        !data.asignacion
                          ? "Liberar tripulante"
                          : "Quitar asignacion de unidad"
                      }
                      onClick={async () => {
                        if (!data) return;

                        if (!data.asignacion) {
                          const result = await Swal.fire({
                            title: `¿Estás seguro de liberar al ${
                              data.tipo_tripulante_id === 2
                                ? "Maniobra"
                                : "Operador"
                            }?`,
                            showCancelButton: true,
                            confirmButtonText: "Aceptar",
                          });

                          if (result.isConfirmed) {
                            await liberarUnidad();
                          }

                          return;
                        }

                        const unidad =
                          data?.asignacion?.unidad?.numero || "sin identificar";

                        const result = await Swal.fire({
                          title: `¿Estás seguro de finalizar y liberar a los tripulantes del viaje en la unidad ${unidad}?`,
                          showCancelButton: true,
                          confirmButtonText: "Aceptar",
                        });

                        if (result.isConfirmed) {
                          await liberarUnidad();
                        }
                      }}
                    ></FontAwesomeIcon>
                  )}
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  Cargando...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};
